export const GET_TAGS = "GET_TAGS";
export const RESET_TAGS = "RESET_TAGS";
export const SET_TAGS_REQUEST_STATUS = "SET_TAGS_REQUEST_STATUS";
export const REMOVE_TAG = "REMOVE_TAG";
export const ADD_TAG = "ADD_TAG";
export const UPDATE_TAG = "UPDATE_TAG";
